import { render, staticRenderFns } from "./WuZiResign.vue?vue&type=template&id=06573f14&scoped=true"
import script from "./WuZiResign.vue?vue&type=script&lang=js"
export * from "./WuZiResign.vue?vue&type=script&lang=js"
import style0 from "./WuZiResign.vue?vue&type=style&index=0&id=06573f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06573f14",
  null
  
)

export default component.exports